import { v4 as uuid } from "uuid";
export var getTracingId = function () {
    var key = "tracingId";
    var value = localStorage.getItem(key);
    if (!value) {
        value = uuid();
        localStorage.setItem(key, value);
    }
    return value;
};
//# sourceMappingURL=getUniqueValue.js.map